/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions */
import { ArrowRight, Play } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

import { careerStory, StoryIdentity } from "./career-story";

export const SpotlightSection = () => {
  const { user } = useAuthStore();
  const [playing, setPlaying] = useState(false);
  return (
    <section id="spotlight-intros" className="folio-section folio-spotlight">
      <div className="folio-shell">
        <div className="spotlight-grid">
          <div className="spotlight-copy">
            <p className="folio-eyebrow">Spotlight Intro</p>
            <h2>Let them meet the person behind the page.</h2>
            <p className="folio-lead">
              You speak. An AI host guides the conversation. Record a video introduction in your own
              words, with a saved transcript that gives recruiters more context alongside your
              resume.
            </p>
            <p className="spotlight-product-note">
              When reviewing candidates for a role, recruiters can search relevant details from
              Spotlight transcripts—not just resume text.
            </p>
            <Link
              className="folio-text-link"
              to={user ? "/dashboard/spotlight-intro" : "/auth/register"}
            >
              Create your Spotlight Intro <ArrowRight size={17} />
            </Link>
          </div>
          <figure className="spotlight-film">
            <div className="spotlight-film-player">
              {playing ? (
                <video
                  controls
                  autoPlay
                  playsInline
                  aria-label="Spotlight Intro product walkthrough"
                  poster="/images/spotlight-human-poster-v2.webp"
                >
                  <source src="/videos/video-intro-demo.mp4" type="video/mp4" />
                  Your browser does not support video playback.
                </video>
              ) : (
                <button
                  type="button"
                  onClick={() => setPlaying(true)}
                  aria-label="Play the 52-second Spotlight Intro product walkthrough"
                >
                  <img
                    src="/images/spotlight-human-poster-v2.webp"
                    alt="A person appearing in the existing Spotlight Intro product recording"
                    width="422"
                    height="238"
                    loading="lazy"
                  />
                  <span className="spotlight-play">
                    <Play size={22} fill="currentColor" />
                    Watch the walkthrough <small>0:52</small>
                  </span>
                </button>
              )}
            </div>
            <figcaption>
              <span className="folio-label">Inside Spotlight Intro</span>
              <span>Actual product recording</span>
            </figcaption>
          </figure>
        </div>
        <div className="spotlight-example">
          <StoryIdentity detail="Avery’s illustrative intro" />
          <blockquote>“{careerStory.intro}”</blockquote>
          <p>
            One experience.
            <br />A much fuller explanation.
          </p>
        </div>
      </div>
    </section>
  );
};
